import backofficeService from '../../api/backoffice'

export default {  
  getSalesByPeriod(params) {
    return backofficeService.Api().get('sales/salesByPeriod', { params })
      .then(response => response.data)
      .catch(error =>{ throw error})
  },
  averageSaleByPeriod(params) {
    return backofficeService.Api().get('sales/averageSaleByPeriod', { params })
      .then(response => response.data)
      .catch(error =>{ throw error})
  },
}
